import {Component, OnInit} from '@angular/core';
import {AppConfigService} from '../app-config.service';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators, ReactiveFormsModule } from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {SelectGeneric, SelectTipo} from '../interface/selectTipo.interface';
import {TipoSelectService} from '../services/tipoSelect.service';
import {TipoDeUso} from '../interface/tipo-uso.interface';
import swal from 'sweetalert2';
import {AddBillingService} from '../services/add-billing.service';
import {Router} from '@angular/router';
import {ClientInfoVO} from '../interface/client-info-vo.interface';
import {ConsultaRFC} from '../interface/consultaRFC.interface';
import {DataUser} from '../interface/person.interface';

export class FiscalNacional {
  constructor(
      public email: string = '',
      public password: string = '',
      public rfc: string = '',
      public personType: string = '',
      public name: string = '',
      public patternName: string = '',
      public maternalName: string = '',
      public postalCode: string = '',
      public regimenFiscal: string = '',
      public regionId: string = '',
      public fiscalResidence: string = '',
      public tipoUso: string = '',
      public isForegein: boolean = false,
      public razonSocial: string = '',
  ) {}
}

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.css']
})

export class AddressFormComponent implements OnInit {
  logoHeader = '';
  form: FormGroup;
  regimenFiscalList: SelectTipo[] = [];
  tipoUsoList: SelectTipo[] = [];
  tipoUso: TipoDeUso;
  rfcUser: ClientInfoVO;

  dataInvoice: DataUser;
  isValitingRfc: boolean;
  residenciasFiscales: SelectTipo[] = [];
  consultaRFC: ConsultaRFC;

  constructor(
      private configService: AppConfigService,
      private fb: FormBuilder,
      private dialogRef: MatDialogRef<AddressFormComponent>,
      private tipoSelect: TipoSelectService,
      private addBillingAddress: AddBillingService,
      private router: Router,
      private tipoSelectService: TipoSelectService,
  ) {
    this.logoHeader = this.configService.getConfig().logoHeader;

    this.form = this.fb.group({
      email: [localStorage.getItem('userEmail')],
      password: [localStorage.getItem('password')],
      personType: ['', Validators.required],
      rfc: ['', {
        validators: [
          this.rfcValidator(),
          Validators.required
        ]
      }],
      name: [''],
      patternName: [''],
      maternalName: [''],
      postalCode: ['', [Validators.required, Validators.pattern(/^\d{5}$/)]],
      regimenFiscal: ['', Validators.required],
      regionId: [''],
      fiscalResidence: [''],
      tipoUso: ['', Validators.required],
      isForegein: [false],
      razonSocial: [''],
    });

    // tslint:disable-next-line:no-non-null-assertion
    this.form.get('personType')!.valueChanges.subscribe(tipo => {
      // tslint:disable-next-line:no-non-null-assertion
      const rfcControl = this.form.get('rfc')!;
      const requiredLength = tipo === 'F' ? 13 : 12;

      rfcControl.setValidators([
        Validators.required,
        this.rfcValidator(),
        Validators.minLength(requiredLength),
        Validators.maxLength(requiredLength),
      ]);

      rfcControl.updateValueAndValidity();
    });


    // tslint:disable-next-line:no-non-null-assertion
    this.form.get('personType')!.valueChanges
        // tslint:disable-next-line:no-non-null-assertion
        .subscribe(() => this.form.get('rfc')!.updateValueAndValidity());
  }

  onPersonTypeChange(): void {
    const personType = this.form.get('personType').value;

    if (personType === 'F') { // Persona Física
      this.form.get('name').enable();
      this.form.get('name').setValidators( [Validators.required, Validators.pattern(/^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$/)]);

      this.form.get('patternName').enable();
      this.form.get('patternName').setValidators( [Validators.required, Validators.pattern(/^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$/)]);

      this.form.get('maternalName').enable();
      this.form.get('maternalName').setValidators( [Validators.required, Validators.pattern(/^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$/)]);


      this.form.get('razonSocial').disable();
      this.form.get('razonSocial').setValue('');
      this.form.get('razonSocial').clearValidators();
    } else if (personType === 'M') { // Persona Moral
      this.form.get('name').disable();
      this.form.get('name').setValue('');
      this.form.get('patternName').disable();
      this.form.get('patternName').setValue('');
      this.form.get('maternalName').disable();
      this.form.get('maternalName').setValue('');

      this.form.get('razonSocial').enable();
      this.form.get('razonSocial').setValidators([
        Validators.required,
        Validators.pattern(/^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$/)
      ]);
    }

    // Refresca validación de todos los campos afectados
    this.form.get('name').updateValueAndValidity();
    this.form.get('patternName').updateValueAndValidity();
    this.form.get('maternalName').updateValueAndValidity();
    this.form.get('razonSocial').updateValueAndValidity();
  }


  allowOnlyLetters(event: KeyboardEvent): void {
    const key = event.key;

    // Permitir letras mayúsculas, minúsculas, y teclas de control como backspace
    const isLetter = /^[A-Za-zÁÉÍÓÚáéíóúÑñ ]+$/.test(key);
    const isControlKey = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'].includes(key);

    if (!isLetter && !isControlKey) {
      event.preventDefault(); // Bloquea cualquier otra tecla
    }
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const key = event.key;

    // Permitir letras mayúsculas, minúsculas, y teclas de control como backspace
    const isLetter = /^[0-9]$/.test(key);
    const isControlKey = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'].includes(key);

    if (!isLetter && !isControlKey) {
      event.preventDefault(); // Bloquea cualquier otra tecla
    }
  }


  close() {
    this.dialogRef.close();
  }

  ngOnInit() {

    this.form.get('personType').valueChanges.subscribe(value => {
      console.log('PersonType', value);
      if (value !== '') {
        this.getRegimenFiscalList(value);
      } else {
        this.regimenFiscalList = [];
      }
    });

    this.form.get('regimenFiscal').valueChanges.subscribe(value => {
      console.log('RegimenFiscalList', value);
      this.tipoUso = {regFiscalId: this.form.get('regimenFiscal').value, typePerson: this.form.get('personType').value};
      if (value !== '') {
        this.getTipoUsoList(this.tipoUso);
      } else {
        this.tipoUsoList = [];
      }
    });
  }

  getRegimenFiscalList(personType: string) {
    this.tipoSelect.getRegimenFiscalList(personType).subscribe(
        (response: SelectGeneric) => {
          this.regimenFiscalList = response.object;
          console.log('Lista de regímenes fiscales:', this.regimenFiscalList);
        },
        (error) => {
          console.error('Error al obtener los regímenes fiscales', error);
        });
  }

  getTipoUsoList(tipoUso: TipoDeUso) {
    this.tipoSelect.getUsageTypeList(tipoUso).subscribe((response: SelectGeneric) => {
      this.tipoUsoList = response.object;
      //console.log('Lista de usages fiscales:', this.tipoUsoList);
    });
  }

  getResidenciaFisc() {
    this.tipoSelect.getResidenciasFiscales().subscribe((data: SelectGeneric) => {
      console.log('DATA: ', data);
      if (!data.status) {
        swal('Error!', data.msg, 'error');
      } else {
        this.residenciasFiscales = data.object;
      }
    });
  }

  convertirEnMayusculas(campo: string) {
    const control = this.form.get(campo);
    if (control) {
      control.setValue(control.value.toUpperCase(), {emitEvent: false});
    }
  }

  rfcValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      // Valor del RFC en mayúsculas (o cadena vacía si es null/undefined)
      const raw = control.value;
      const rfc = raw ? String(raw).toUpperCase() : '';

      // Intentamos obtener el formulario y el tipo de persona
      const form = control.parent;
      const tipoControl = form ? form.get('personType') : null;
      const tipo = tipoControl ? tipoControl.value : null;

      // Patrones oficiales
      const patronFisica = /^[A-ZÑ&]{4}\d{6}[A-Z0-9]{3}$/;
      const patronMoral = /^[A-ZÑ&]{3}\d{6}[A-Z0-9]{3}$/;

      // Si está vacío, es requerido
      if (!rfc) {
        return {required: true};
      }

      // Determinamos validez según tipo
      let valido: boolean;
      if (tipo === 'F') {
        valido = patronFisica.test(rfc);
      } else if (tipo === 'M') {
        valido = patronMoral.test(rfc);
      } else {
        // Si no conocemos el tipo, no validamos patrón
        return null;
      }

      // Si es válido, no hay error; si no, devolvemos pattern
      return valido
          ? null
          : {
            pattern: {
              requiredPattern: tipo === 'F' ? patronFisica : patronMoral,
              actualValue: rfc
            }
          };
    };
  }

  sendData() {
    if (this.form.invalid) {
      swal('Error', 'Llena todos los campos correctamente antes de enviar.', 'error');
      this.form.markAsTouched();
      return;
    }

    this.isValitingRfc = true;
    // tslint:disable-next-line:no-non-null-assertion
    this.rfcUser = {rfc: this.form.get('rfc')!.value.toUpperCase()};
    console.log('RFC: ', this.rfcUser);

    console.log(this.form.get('personType').value);
    console.log('Consulta RFC: ', this.consultaRFC);

    console.log(this.form.get('name').value + ' ' + this.form.get('patternName').value + ' ' + this.form.get('maternalName').value);
    console.log(this.form.get('postalCode').value);
    console.log(this.form.get('regimenFiscal').value);
    console.log(this.form.get('regionId').value);
    if (this.form.get('personType').value === 'F') {
      this.consultaRFC = {
        businessName: this.form.get('name').value + ' ' + this.form.get('patternName').value + ' ' + this.form.get('maternalName').value,
        postalCode: this.form.get('postalCode').value,
        regimenFiscal: this.form.get('regimenFiscal').value,
        rfc: this.rfcUser.rfc
      };

    } else {
      this.consultaRFC = {
        businessName: this.form.get('razonSocial').value,
        postalCode: this.form.get('postalCode').value,

        regimenFiscal: this.form.get('regimenFiscal').value,
        rfc: this.rfcUser.rfc
      };
    }

      console.log('Consulta RFC: ', this.consultaRFC);

      // 1) validación remota del RFC
      this.tipoSelect.validaRFC(this.consultaRFC).subscribe({
        next: data => {
          console.log('getRfcStatusData: ', data);
          if (data ['msg'] === 'OK') {
            console.log('DATA: ', data);
            const formData: FiscalNacional = this.form.value;
            formData.rfc = this.rfcUser.rfc;  // asegúrate de poner el RFC en mayúsculas

            this.addBillingAddress.addBilling(formData).subscribe({
              next: response => {
                console.log('RESPONSE: ', response);
                this.isValitingRfc = false;
                if (response) {
                  swal('Éxito', 'Datos guardados correctamente', 'success');
                  this.dialogRef.close(response);
                } else {
                  swal('Error', 'No se pudo guardar la dirección.', 'error');
                }
              },
              error: () => {
                this.isValitingRfc = false;
                swal('Error', 'Error al enviar los datos.', 'error');
              }
            });
          } else {
            this.isValitingRfc = false;
            if (
                data['msg'].toLowerCase().includes('xml mal formado') ||
                data['msg'].toLowerCase().includes('object reference not set to an instance of an object')
            ) {
              swal('Error', 'Revisa que tu RFC esté bien escrito o sea el correcto', 'error');
            } else {
              swal('Error', data['msg'], 'error');
            }
          }
        },
        error: () => {
          this.isValitingRfc = false;
          swal('Error', 'No se pudo validar el RFC en el servidor.', 'error');
        }
      });
    }
}
